import { useEffect, useState } from "react";
import HelmetTags from "../../../../MainComponents/HelmetTags";
import AddEditDashboardContent from "./AddEditDashboardContent";
import useAxios from "../../../../MainComponents/Hooks/useAxios";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "../../../../MainComponents/GlobalContext";
import Loader from "../../../../MainComponents/Loader.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";

function getStageLabel(stage) {
  if (+stage === 1) return "1st sec";
  if (+stage === 2) return "2nd sec";
  if (+stage === 3) return "3rd sec";
  return "";
}

function getSystemLabel(systemType) {
  if (systemType === "hand_by_hand") return "ايد بايد";
  if (systemType === "normal") return "النظام العادي";
  if (systemType === "all") return "الكل";
  return "";
}

function Dashboard() {
  const navigate = useNavigate();
  const [reFetch, setReFetch] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const AuthState = useAuthState();

  const [submitDelete, setSubmitDelete] = useState({
    flag: "",
    dependency: false,
    data: {},
  });

  const [postsDataSuccess, postsErrors, postsDataLoading] = useAxios(
    process.env.REACT_APP_ALL_DASHBOARD_POSTS_API,
    "GET",
    "GET",
    reFetch,
  );

  const [deleteQuestionSuccess] = useAxios(
    process.env.REACT_APP_DELETE_DASHBOARD_POST_API,
    "POST",
    submitDelete.flag,
    submitDelete.dependency,
    submitDelete.data,
    true,
  );

  useEffect(() => {
    if (deleteQuestionSuccess) {
      setReFetch(!reFetch);
      setDeleteId("");
    }
  }, [deleteQuestionSuccess]);

  function handleDelete() {
    setSubmitDelete({
      flag: "deleteQuestion",
      dependency: !submitDelete.dependency,
      data: { id: deleteId },
    });
  }

  const canDelete =
    AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
    AuthState.userData?.admin?.permissions?.some((p) =>
      p.name.startsWith("post_delete"),
    );

  const canEdit =
    AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
    AuthState.userData?.admin?.permissions?.some((p) =>
      p.name.startsWith("post_edit"),
    );

  if (postsDataLoading) {
    return <Loader />;
  }

  return (
    <section className="h-full w-full overflow-y-auto bg-white px-10 py-10 text-slate-900 dark:bg-dark dark:text-light sm:px-4">
      <HelmetTags title="Dashboard | Mr.Mohamed Salama" />
      <h2 className="mb-7 text-start text-2xl font-bold sm:text-center">
        Dashboard
      </h2>

      {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
        AuthState.userData?.admin?.permissions?.some((permission) =>
          permission.name.startsWith("post_add"),
        )) && (
        <AddEditDashboardContent setReFetch={setReFetch} reFetch={reFetch} />
      )}

      {deleteId && (
        <div className="dashboard-delete-modal">
          <div className="dashboard-delete-modal__card">
            <p className="dashboard-delete-modal__text">
              Are you sure you want to delete?
            </p>
            <div className="dashboard-delete-modal__actions">
              <button
                type="button"
                onClick={() => setDeleteId("")}
                className="dashboard-delete-modal__close"
              >
                Close
              </button>
              <button
                type="button"
                onClick={handleDelete}
                className="dashboard-delete-modal__confirm"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {postsErrors && typeof postsErrors === "string" ? (
        <div className="mt-10 w-full text-center">
          <p>{postsErrors}</p>
        </div>
      ) : (
        <div className="dashboard-posts">
          {postsDataSuccess?.data?.map((post) => (
            <article key={post.key} className="dashboard-post-card">
              <header className="dashboard-post-card__header">
                <div className="dashboard-post-card__meta">
                  <p className="dashboard-post-card__id">Post #{post?.n}</p>
                  <p className="dashboard-post-card__date">{post?.created_at}</p>
                </div>
                <div className="dashboard-post-card__badges">
                  {getStageLabel(post?.stage) && (
                    <span className="dashboard-post-card__badge">
                      {getStageLabel(post?.stage)}
                    </span>
                  )}
                  {+post.stage === 3 && post?.section && (
                    <span className="dashboard-post-card__badge dashboard-post-card__badge--section">
                      {post.section}
                    </span>
                  )}
                  {+post.stage === 3 && getSystemLabel(post?.system_type) && (
                    <span className="dashboard-post-card__badge dashboard-post-card__badge--section">
                      {getSystemLabel(post.system_type)}
                    </span>
                  )}
                </div>
              </header>

              <div
                className="dashboard-post-card__body"
                dangerouslySetInnerHTML={{ __html: post?.content }}
              />

              {(canEdit || canDelete) && (
                <footer className="dashboard-post-card__footer">
                  {canEdit && (
                    <button
                      type="button"
                      className="dashboard-post-card__btn dashboard-post-card__btn--edit"
                      onClick={() =>
                        navigate(`/admin/dashboard/edit-post/${post.key}`)
                      }
                    >
                      <FontAwesomeIcon icon={faPen} />
                      Edit
                    </button>
                  )}
                  {canDelete && (
                    <button
                      type="button"
                      className="dashboard-post-card__btn dashboard-post-card__btn--delete"
                      onClick={() => setDeleteId(post.key)}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                      Delete
                    </button>
                  )}
                </footer>
              )}
            </article>
          ))}
        </div>
      )}
    </section>
  );
}

export default Dashboard;
